import get, { post } from '../../utils/http-utils';

export function getUIInputData() {
    return get("/filecopyutility/dbuidata");
}

export function executeJob(body) {
    return post('/filecopyutility/triggerjob', { "content-type": "application/json" }, body);
}